import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type Loader = {
  loading: boolean;
  message: string;
};

interface AppConfigState {
  CLM_URL: string;
  MSD_URL: string;
  CMP_URL: string;
  BR_MANAGEMENT_URL: string;
  loader: {
    loading: boolean;
    message: string;
  };
  userId: string | null;
  env: string;
  error: {
    message: string;
    open: boolean;
  };
}

const initialState: AppConfigState = {
  CLM_URL: '',
  MSD_URL: '',
  CMP_URL: '',
  BR_MANAGEMENT_URL: '',
  loader: {
    loading: false,
    message: '',
  },
  userId: null,
  env: 'UNKNOWN',
  error: {
    message: '',
    open: false,
  },
};

const appConfigSlice = createSlice({
  name: 'appConfigSlice',
  initialState: initialState,
  reducers: {
    setClmUrl(state, action: PayloadAction<string>) {
      state.CLM_URL = action.payload;
    },
    setMsdUrl(state, action: PayloadAction<string>) {
      state.MSD_URL = action.payload;
    },
    setCmpUrl(state, action: PayloadAction<string>) {
      state.CMP_URL = action.payload;
    },
    setBrManagementUrl(state, action: PayloadAction<string>) {
      state.BR_MANAGEMENT_URL = action.payload;
    },
    setLoader(state, action: PayloadAction<Loader>) {
      state.loader = action.payload;
    },
    setUserId(state, action: PayloadAction<string>) {
      state.userId = action.payload;
    },
    setEnv(state, action: PayloadAction<string>) {
      state.env = action.payload;
    },
  },
});

export const { setClmUrl, setMsdUrl, setCmpUrl, setBrManagementUrl, setLoader, setUserId, setEnv } =
  appConfigSlice.actions;

export default appConfigSlice.reducer;
